<template>
  <div>
      <div class="col-3">
          <icon :icon="this.icon" /> {{ this.title }}
      </div>
      <div class="col-9">
      </div>
  </div>
</template>

<script>
import icon from "@/assets/icons/icons";

export default {
  name: "Toolbar",
  props: {
    title: {
      type: String,
      required: false
    },
    icon: {
      type: String,
      required: false
    },
    className: {
      type: String,
      default: "tag-pill tag-default"
    }
  },
  computed: {
    homeRoute: () => ({ name: "home-tag", params: { tag: name } })
  },
  components: {
      icon
  }
};
</script>
